import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import ConversionItemContent from './ConversionItemContent';
import { actions } from './ConversionItemContent.actions';
import {
    mainSelector,
    isEmpty
} from './ConversionItemContent.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    data: mainSelector,
    isEmpty: isEmpty
});

const ConversionItemContentComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.conversions.loading
        };
    },
    null
)(ConversionItemContent);

export default ConversionItemContentComponent;
